// :cow: Cosmose CONFIDENTIAL :iso:
import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackbarService } from '../services/snackbar.service';

const HANDLED_ENDPOINT_PATHS: readonly string[] = [
  '/v1/publication-content',
  '/v1/lockscreen-resources',
  '/v1/video',
  '/v1/ranked-videos',
  '/v1/trending-news',
  '/v1/global-search',
  '/v1/batch-video',
  '/v1/video-creators',
];

@Injectable()
export class BadRequestInterceptor implements HttpInterceptor {
  private readonly snackbarService = inject(SnackbarService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((error: unknown) => {
        if (error instanceof HttpErrorResponse && error.status === 400 && this.isHandledEndpoint(request.url)) {
          const message = this.extractMessage(error);
          if (message) {
            this.snackbarService.error(message);
          }
        }
        return throwError(() => error);
      }),
    );
  }

  private isHandledEndpoint(url: string): boolean {
    const path = this.extractPath(url);
    return HANDLED_ENDPOINT_PATHS.some((endpoint) => path.endsWith(endpoint));
  }

  private extractPath(url: string): string {
    try {
      return new URL(url).pathname;
    } catch {
      return url.split('?')[0];
    }
  }

  private extractMessage(error: HttpErrorResponse): string | null {
    const payload = error.error;
    if (payload && typeof payload === 'object' && typeof (payload as { msg?: unknown }).msg === 'string') {
      return (payload as { msg: string }).msg;
    }
    return null;
  }
}
